export default __webpack_public_path__ + "static/media/36I-102751_-15851_0.e27ac28e.jpg";